module.exports = __webpack_public_path__ + "img/2438.3af542bc.gif";